import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import { fetchApi } from '@/config/axiosSetting.ts';

type ResponseType = Promise<
  PaginationResponseType<{ const: string; fa_const: string }[]>
>;
export const plateDesignRequest = ({
  plateDesignName,
}: {
  plateDesignName: string | null;
}): ResponseType =>
  fetchApi({
    method: 'GET',
    url: 'selection_item/plate_design/list/',
    params: { name: plateDesignName },
  });
